import React, { useEffect } from 'react'
import { Link, Redirect, useHistory, useLocation } from 'react-router-dom'
import Header from '../Component/Header'
import Footer from '../Component/footer'
import { canAccessManage, hasModule, isLoggedIn } from './auth'
import { MANAGE_MODULES } from './modules'
import './Manage.css'

function ManageLayout({ children }) {
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    if (!isLoggedIn()) {
      history.replace('/Login')
      return
    }
    if (!canAccessManage()) {
      history.replace('/')
    }
  }, [history, location.pathname])

  if (!isLoggedIn()) {
    return <Redirect to="/Login" />
  }
  if (!canAccessManage()) {
    return <Redirect to="/" />
  }

  const navItems = MANAGE_MODULES.filter((m) => hasModule(m.key))

  return (
    <div className="manage-shell">
      <Header />
      <div className="container-fluid manage-body">
        <div className="row">
          <aside className="col-md-3 col-lg-2 manage-sidebar py-3">
            <div className="manage-sidebar-title px-2 mb-2">Manage</div>
            <nav className="nav flex-column">
              {navItems.map((item) => {
                const active = item.exact
                  ? location.pathname === item.path
                  : location.pathname === item.path ||
                    location.pathname.startsWith(item.path + '/')
                return (
                  <Link
                    key={item.key}
                    to={item.path}
                    className={`nav-link manage-nav-link${active ? ' active' : ''}`}
                  >
                    {item.label}
                  </Link>
                )
              })}
            </nav>
          </aside>
          <main className="col-md-9 col-lg-10 manage-main py-3">
            {children}
          </main>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default ManageLayout
